<mat-card>
  <mat-card-header>
    <div mat-card-avatar>
      <img *ngIf="avatar$ | async as avatar" [style.background-image]="bypassSecurity('url(' + avatar + ')')">
    </div>
    <mat-card-title>
      <div class="mat-card-title-text">{{activity?.account?.supplierName}}</div>
    </mat-card-title>
    <mat-card-subtitle>
      <div>{{activity?.createdBy?.name}} | {{activity?.createdOn | date:'MM/dd E H:mm:ss'}}</div>
      <div>{{title}}</div>
    </mat-card-subtitle>
    <div class="card-buttons">
      <a *ngIf="isLinkActive" mat-icon-button color="accent" routerLink="/accounts/{{activity.account?.id}}">
        <mat-icon aria-label="Edit">arrow_forward_ios</mat-icon>
      </a>
    </div>
  </mat-card-header>
  <div *ngIf="hasImage" class="image-grid">
    <app-image-grid [urls]=activity?.account?.images></app-image-grid>
  </div>
</mat-card>